/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Materialclosetposition2Inputs */

const de__field_materialclosetposition2 = /** @type {(inputs: _Field_Materialclosetposition2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Materialschrank-Position`)
};

/**

* @param {_Field_Materialclosetposition2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_materialclosetposition2 = /** @type {((inputs?: _Field_Materialclosetposition2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Materialclosetposition2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_materialclosetposition2(inputs)
});
export { _field_materialclosetposition2 as "_field_materialClosetPosition" }